import { useEffect, useState } from "react"
import VisitAchievePendingModal from "./Modal/VisitAchievePendingModal"
import { useDispatch, useSelector } from "react-redux"
import { GetChecklistProgressSelectDataAPI } from "../../../../../Redux/GardenDashboardSlice/DailyPreventiveWorkSlice"
import { useAuthState } from "../../../../../Helper/Context"
import { Loading } from "../../../../../Helper/Loading"
import { useTranslation } from "react-i18next"
import EmployeeAndContractorWorkPopup from "../../GarderDashboardComponent/EmployeeAndContractorWiseWorkPending/CountPopup/TotalCountPopup"

export const GardenWorkDailyChecklist = (props) => {
    const {
        YearValue,
        MonthValue,
        WardValue,
        ZoneValue,
        AssetType,
        Date,
        Language,
        WorkActiveButton,
        ActiveButton,
    } = props


    const { t } = useTranslation()

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails

    const [OpenModal, setOpenModal] = useState(false)
    const [Flag, setFlag] = useState('')
    const [weekID, setWeekID] = useState(0)

    const [tableData, settableData] = useState([])
    const [apiFlag, setapiFlag] = useState('')
    const [Data, setData] = useState('')
    const [loader, setloader] = useState(false)

    const [EmployeeAndContractorWorkPopupShow, setEmployeeAndContractorWorkPopupShow] = useState({
        show: false,
        data: '',
        ShowBy: ''
    })

    const handleEmployeeAndContractorWorkPopup = (data, ShowBy) => {
        setEmployeeAndContractorWorkPopupShow({
            show: true,
            data: data,
            ShowBy: ShowBy
        })
    }


    const handleOnCloseClick = () => {
        setEmployeeAndContractorWorkPopupShow({
            show: false,
            data: '',
        })
    }

    const handleOpenModal = (flag, data, APIFlag, week) => {
        if (flag == 'Visit Target') {
            if ((data?.m_UserID != 4 && data?.m_UserID != 2364 && data?.m_UserID != 2363 && data?.m_UserID != 30 && data?.m_UserID != 32)) {
                setOpenModal(!OpenModal)
            }
        }
        if (flag == 'Achievement') {
            setOpenModal(!OpenModal)
        }
        if (flag == 'Pending') {
            console.log('')
        }
        setWeekID(week) // for getting weekid
        setFlag(flag)
        setData(data)
        setapiFlag(APIFlag)
    }

    useEffect(() => {
        setloader(true)
        const data = {
            M_FinancialYearID: YearValue,
            M_MonthID: MonthValue,
            M_ZoneID: ZoneValue,
            Date: Date,
            M_AssetTypeID: AssetType,
            M_WorkTypeID: RoleID == 12 ? 3 : WorkActiveButton,
            M_WardID: WardValue,
            M_UsersID: UserID,
            token: token,
            From: 1,
            To: 99999,
            Flag: 'Garden',
            handleGetData: handleGardenData,
            Language: Language?.Label,
            setloader: setloader
        }

        {
            ((YearValue != 0 && MonthValue != 0) && (Language?.Label != undefined && Date != undefined) && Language?.Label != '') &&
                dispatch(GetChecklistProgressSelectDataAPI({ data }))
        }
    }, [YearValue, MonthValue, ZoneValue, WardValue, Date, Language?.Label, WorkActiveButton])

    const handleGardenData = (result) => {
        settableData(result)
    }

    const { isLoading } = useSelector(state => state.GetChecklistProgressSelectData)


    return (
        <>
            <div className="row ps-3 pb-3 pe-0">
                {loader && <Loading />}
                <div className="col-12 mb-3 ps-0 pe-0">
                    <div style={{ height: '65vh' }} className='row mob_table table-responsive p-2'>

                        <table id="totalordergenerated"
                            cellPadding="0"
                            cellSpacing="0"
                            border="0"
                            className="table table-bordered " >
                            <thead className="gardenworktable" id="customers" style={{ position: 'sticky', top: -10 }} >


                                <tr className="text-center tablethhead">
                                    {
                                        tableData && tableData.mainHeading && tableData.mainHeading.length > 0 && tableData.mainHeading.map((i) => {
                                            return (
                                                <th colSpan={i.no} className="text-center fw-bold fs-6" id="tablecolor" >{i.manihead}</th>

                                            )
                                        })
                                    }
                                </tr>

                                <tr className="text-center gardenworkth" style={{ width: '100%' }}>
                                    {
                                        tableData && tableData.heading && tableData.heading.length > 0 && tableData.heading.map((j) => {

                                            return (
                                                <th className={Language?.Label == 'English' ? "text-center fw-bold widthmanage " : "text-center fw-bold"} style={{ whiteSpace: 'nowrap' }} >{j.head}</th>
                                            )
                                        })
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    tableData && tableData.data && tableData.data.length > 0 ? tableData.data.map((officer) => {
                                        return (
                                            <tr className="text-center" >

                                                <td className="verticalAllign">{officer?.designationName}</td>
                                                <td className="verticalAllign">{officer?.employeeName}</td>
                                                <td className="text-center verticalAllign">{officer?.zoneName}</td>
                                                <td className="text-center verticalAllign  bluecolorCount" onClick={(e) => (officer?.week1_VisitTarget == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Visit Target', officer, 'VisitTarget_Week1', 1)}>
                                                    <span className={(
                                                        officer?.week1_VisitTarget != 0 && WorkActiveButton == 1 && (officer?.m_UserID != 4 && officer?.m_UserID != 2364 && officer?.m_UserID != 2363 && officer?.m_UserID != 30 && officer?.m_UserID != 32)
                                                    ) ? "cursor-pointer_bg" : "cursor-none"}>
                                                        {officer?.week1_VisitTarget}
                                                    </span>

                                                </td>

                                                <td className="text-center verticalAllign  greencolorCount" onClick={(e) => officer?.week1_Achievement == 0 ? e.preventDefault() : handleOpenModal('Achievement', officer, 'Achievement_Week1', 1)} >
                                                    <span className={officer?.week1_Achievement != 0 ? "cursor-pointer_bg" : "cursor-none"}>
                                                        {officer?.week1_Achievement}
                                                    </span>
                                                </td>

                                                <td className="text-center verticalAllign cursor-pointer orangecolorCount" onClick={(e) => (officer?.week1_Pending == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Pending', officer, 'Pending_Week1', 1)}>{officer?.week1_Pending}</td>

                                                <td className="text-center verticalAllign cursor-pointer bluecolorCount" onClick={(e) => (officer?.week2_VisitTarget == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Visit Target', officer, 'VisitTarget_Week2', 2)}>
                                                    <span className={(
                                                        officer?.week2_VisitTarget != 0 && WorkActiveButton == 1 && (officer?.m_UserID != 4 && officer?.m_UserID != 2364 && officer?.m_UserID != 2363 && officer?.m_UserID != 30 && officer?.m_UserID != 32)
                                                    ) ? "cursor-pointer_bg" : "cursor-none"}>
                                                        {officer?.week2_VisitTarget}
                                                    </span>
                                                </td>

                                                <td className="text-center verticalAllign cursor-pointer greencolorCount" onClick={(e) => officer?.week2_Achievement == 0 ? e.preventDefault() : handleOpenModal('Achievement', officer, 'Achievement_Week2', 2)}>
                                                    <span className={officer?.week2_Achievement != 0 ? "cursor-pointer_bg" : "cursor-none"}>
                                                        {officer?.week2_Achievement}
                                                    </span>
                                                </td>

                                                <td className="text-center verticalAllign cursor-pointer orangecolorCount" onClick={(e) => (officer?.week2_Pending == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Pending', officer, 'Pending_Week2', 2)}>{officer?.week2_Pending}</td>

                                                <td className="text-center verticalAllign cursor-pointer bluecolorCount" onClick={(e) => (officer?.week3_VisitTarget == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Visit Target', officer, 'VisitTarget_Week3', 3)}>
                                                    <span className={(
                                                        officer?.week3_VisitTarget != 0 && WorkActiveButton == 1 && (officer?.m_UserID != 4 && officer?.m_UserID != 2364 && officer?.m_UserID != 2363 && officer?.m_UserID != 30 && officer?.m_UserID != 32)
                                                    ) ? "cursor-pointer_bg" : "cursor-none"}>
                                                        {officer?.week3_VisitTarget}
                                                    </span>
                                                </td>

                                                <td className="text-center verticalAllign cursor-pointer greencolorCount" onClick={(e) => officer?.week3_Achievement == 0 ? e.preventDefault() : handleOpenModal('Achievement', officer, 'Achievement_Week3', 3)}>
                                                    <span className={officer?.week3_Achievement != 0 ? "cursor-pointer_bg" : "cursor-none"}>
                                                        {officer?.week3_Achievement}
                                                    </span>
                                                </td>

                                                <td className="text-center verticalAllign cursor-pointer orangecolorCount" onClick={(e) => (officer?.week3_Pending == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Pending', officer, 'Pending_Week3', 3)}>{officer?.week3_Pending}</td>

                                                <td className="text-center verticalAllign cursor-pointer bluecolorCount" onClick={(e) => (officer?.week4_VisitTarget == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Visit Target', officer, 'VisitTarget_Week4', 4)}>
                                                    <span className={(
                                                        officer?.week4_VisitTarget != 0 && WorkActiveButton == 1 && (officer?.m_UserID != 4 && officer?.m_UserID != 2364 && officer?.m_UserID != 2363 && officer?.m_UserID != 30 && officer?.m_UserID != 32)
                                                    ) ? "cursor-pointer_bg" : "cursor-none"}>
                                                        {officer?.week4_VisitTarget}
                                                    </span>
                                                </td>

                                                <td className="text-center verticalAllign cursor-pointer greencolorCount" onClick={(e) => officer?.week4_Achievement == 0 ? e.preventDefault() : handleOpenModal('Achievement', officer, 'Achievement_Week4', 4)}>
                                                    <span className={officer?.week4_Achievement != 0 ? "cursor-pointer_bg" : "cursor-none"}>
                                                        {officer?.week4_Achievement}
                                                    </span>
                                                </td>

                                                <td className="text-center verticalAllign cursor-pointer orangecolorCount" onClick={(e) => (officer?.week4_Pending == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Pending', officer, 'Pending_Week4', 4)}>{officer?.week4_Pending}</td>

                                                {
                                                    (officer?.week5_VisitTarget || officer?.week5_VisitTarget != undefined) &&
                                                    <>
                                                        <td className="text-center verticalAllign cursor-pointer bluecolorCount" onClick={(e) => (officer?.week5_VisitTarget == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Visit Target', officer, 'VisitTarget_Week5', 5)}>
                                                            <span className={(
                                                                officer?.week5_VisitTarget != 0 && WorkActiveButton == 1 && (officer?.m_UserID != 4 && officer?.m_UserID != 2364 && officer?.m_UserID != 2363 && officer?.m_UserID != 30 && officer?.m_UserID != 32)
                                                            ) ? "cursor-pointer_bg" : "cursor-none"}>
                                                                {officer?.week5_VisitTarget}
                                                            </span>
                                                        </td>

                                                        <td className="text-center verticalAllign cursor-pointer greencolorCount" onClick={(e) => officer?.week5_Achievement == 0 ? e.preventDefault() : handleOpenModal('Achievement', officer, 'Achievement_Week5', 5)}>
                                                            <span className={officer?.week5_Achievement != 0 ? "cursor-pointer_bg" : "cursor-none"}>
                                                                {officer?.week5_Achievement}
                                                            </span>
                                                        </td>

                                                        <td className="text-center verticalAllign cursor-pointer orangecolorCount" onClick={(e) => (officer?.week5_Pending == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Pending', officer, 'Pending_Week5', 5)}>{officer?.week5_Pending}</td>
                                                    </>
                                                }

                                                <td className="text-center verticalAllign cursor-pointer bluecolorCount" onClick={(e) => (officer?.total_VisitTarget == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Visit Target', officer, 'VisitTarget_Total', 0)}>
                                                    <span className={(
                                                        officer?.total_VisitTarget != 0 && WorkActiveButton == 1 && (officer?.m_UserID != 4 && officer?.m_UserID != 2364 && officer?.m_UserID != 2363 && officer?.m_UserID != 30 && officer?.m_UserID != 32)
                                                    ) ? "cursor-pointer_bg" : "cursor-none"}>
                                                        {officer?.total_VisitTarget}
                                                    </span>
                                                    {/* {officer?.total_VisitTarget} */}
                                                </td>

                                                <td className="text-center verticalAllign cursor-pointer greencolorCount"
                                                    onClick={(e) => officer?.total_Achievement == 0 ? e.preventDefault() : handleOpenModal('Achievement', officer, 'Achievement_Total', 0)}>
                                                    {/* {officer?.total_Achievement} */}
                                                    <span className={officer?.total_Achievement != 0 ? "cursor-pointer_bg" : "cursor-none"}>
                                                        {officer?.total_Achievement}
                                                    </span>
                                                </td>

                                                <td className="text-center verticalAllign cursor-pointer orangecolorCount" onClick={(e) => (officer?.total_Pending == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Pending', officer, 'Pending_Total', 0)}>{officer?.total_Pending}</td>
                                                
                                                {
                                                    (officer?.kpI_Assign || officer?.kpI_Assign != undefined) &&
                                                    <td className="text-center verticalAllign fw-bold">
                                                        <span className={officer?.kpI_Assign != 0 ? 'cursor-pointer fw-bold bluecolorCount bluecolorCount cursor-pointer_bg' : "cursor-none bluecolorCount"}
                                                            onClick={(e) => officer?.kpI_Assign == 0 ? e.preventDefault() : handleEmployeeAndContractorWorkPopup(officer, 'All')}>
                                                            {officer?.kpI_Assign}
                                                        </span>
                                                    </td>
                                                }

                                            </tr>
                                        );
                                    })
                                        :
                                        <div className='loadingcenter d-flex justify-content-center align-items-center' style={{ height: '33vh', marginTop: '-3%' }}>
                                            <img
                                                src="../assets/img/folder.png"
                                                style={{ height: "9vh", width: '4.5vw', marginLeft: "10px" }}
                                            /><label className='norecordlabel'>&nbsp;&nbsp;No Record Found ...</label>
                                        </div>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {
                OpenModal &&
                <VisitAchievePendingModal
                    handleOpenModal={handleOpenModal}
                    Title={Flag == 'Visit Target' ? t('EmployeeAndContractor.VisitTarget') : Flag == 'Achievement' ? t('EmployeeAndContractor.Achievement') : t('EmployeeAndContractor.Pending')}
                    Flag={Flag}
                    YearValue={YearValue}
                    MonthValue={MonthValue}
                    WardValue={WardValue}
                    ZoneValue={ZoneValue}
                    Language={Language}
                    AssetType={AssetType}
                    Data={Data}
                    apiFlag={apiFlag}
                    setOpenModal={setOpenModal}
                    WorkActiveButton={WorkActiveButton}
                    weekID={weekID}
                />
            }

            {
                EmployeeAndContractorWorkPopupShow.show ?
                    <EmployeeAndContractorWorkPopup
                        open={EmployeeAndContractorWorkPopupShow.show}
                        cancelbtn={handleOnCloseClick}
                        ActiveButton={ActiveButton}
                        GridData={EmployeeAndContractorWorkPopupShow.data}
                        PopUpApiFlag={EmployeeAndContractorWorkPopupShow.flag}
                        ShowBy={EmployeeAndContractorWorkPopupShow.ShowBy}
                        FromDate=''
                        ToDate=''
                        WorkType='0'
                        ZoneNameDDLID='0'
                        WardName='0'
                        flag="Daily Work"
                        YearValue={YearValue}
                        MonthValue={MonthValue}
                        WorkActiveButton={WorkActiveButton}
                        AssetType={AssetType}
                    />
                    : <></>
            }
        </>
    )
}